import { useEffect, useState } from 'react';
import { fetchOne } from '../http/brickAPI';
import { useLocation, useParams } from 'react-router-dom';

import ApplicationModal from '../components/Modals/ApplicationModal';
import { BASE_URL, LOCAL_PHOTO_API_IP, MIXED_PRODUCT_ROUTE, PRODUCT_ROUTE } from '../utils/consts';
import ProductSlider from '../components/Sliders/ProductSlider';
import { Spinner } from 'react-bootstrap';

function ProductPage() {
    const [productData, setProductData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showApplication, setShowApplication] = useState(false);
    const { id } = useParams();
    const location = useLocation();

    useEffect(() => {
        setLoading(true);
        if(location.pathname.includes(MIXED_PRODUCT_ROUTE)){
            fetchOne(id).then(data => {
                setProductData(data.brick);
                setLoading(false);
            }).catch(() => setLoading(false));
        }
        else if (location.pathname.includes(PRODUCT_ROUTE)) {
            fetchOne(id).then(data => {
                setProductData(data.brick);
                setLoading(false);
            }).catch(() => setLoading(false));
        } 
    }, [id, location.pathname]);

    if (loading) {
        return <Spinner animation='grow'/>;
    }

    if (!productData) {
        return <Spinner animation='grow'/>;
    }

    return (
        <div>
        <div className='product-page'>
            <div className='product'>
                <div>
                    <h1 style={{padding:'10px 5px'}}>{productData.name}</h1>
                    <ProductSlider 
                    firstImage={LOCAL_PHOTO_API_IP + productData.image}  
                    secondImage={LOCAL_PHOTO_API_IP + productData.second_image}
                    thirdImage={LOCAL_PHOTO_API_IP + productData.third_image}
                    Video={LOCAL_PHOTO_API_IP + productData.video}
                    />  
                </div>

                    <div className='product-right-side'>
                        <ul>
                            <li >
                            <b> 
                            {productData.description} 
                            </b> 
                            {productData.price} ₽
                            </li>
                            <li>
                            <button 
                                    className='blue-btn' 
                                    onClick={() => setShowApplication(true)}
                                    style={{marginBottom:'1%'}}
                            >
                                Оставить заявку
                                </button>
                                <a 
                                    href={`${BASE_URL}/pdf/download/latest`}
                                    download="price-list.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                <button 
                                    className='blue-btn green'
                                    style={{marginBottom:'2%'}}
                                    >
                                    Скачать прайс лист
                                </button>
                                </a>
                            </li>
                        </ul>
                    </div>  

                </div>
            <ApplicationModal show={showApplication} onHide={() => setShowApplication(false)}/>
        </div></div>
    );
}

export default ProductPage;